import React from 'react';
import { Grid, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NCRFormHeading from '../NCRFormHeading';
import NCRFormLabel from '../NCRFormLabel';
import AILabelBox from '../AILabelBox';
import { handleAIClick } from '../../../Helpers/NCRHelpers';
import NCRSelectField from '../NCRSelectField';
import NCRMultilineTextfields from '../NCRMultilineTextfields';
import NCRTextField from '../NCRTextField';

export default function NDRCEntry({ content, onChange, onAiResponseChange }) {

  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box sx={{ p: 3 }}>
            <Box>
              <NCRFormHeading isRequired={true} tooltipData={
                [
                  { title: "Escape Point", description: "Where did the non-conformance escape detection?" },
                  { title: "Non-Detected Root Cause (NDRC) Identification", description: "Options for common escape causes." },
                  { title: "Corrective Actions for Non-Detected Root Cause (NDRC)", description: "List the measures taken to ensure similar escapes do not occur in the future." }
                ]
              }>
                Non-Detected Root Cause (NDRC) Entry
              </NCRFormHeading>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={2}>
                        <NCRFormLabel>
                          Escape Point:
                        </NCRFormLabel>
                      </Grid>
                      <NCRSelectField
                        size="medium"
                        name="escape_point"
                        value={content.formData.escape_point}
                        onChange={handleInputChange}
                        options={content.lookupTypes?.escapePoint || []}
                        disabled={content.inputDisable}
                        error={!!content?.errors?.escape_point}
                      />
                    </Grid>
                  </Box>
                  {content.formData.escape_point === 'Other' &&
                    <Box sx={{ mb: 2 }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2}>
                          <NCRFormLabel>Escape Point:</NCRFormLabel>
                        </Grid>
                        <NCRTextField
                          size='small'
                          sx={{ width: '340px' }}
                          multiline
                          name="escape_point_other"
                          onChange={handleInputChange}
                          disabled={content.inputDisable}
                          value={content.formData.escape_point_other || ''}
                          placeholder="Enter escape point"
                          error={!!content?.errors?.escape_point_other}
                          maxLength={250}
                        />
                      </Grid>
                    </Box>
                  }
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={2}>
                        <NCRFormLabel>
                          NDRC Identification:
                        </NCRFormLabel>
                      </Grid>
                      <NCRSelectField
                        size="medium"
                        name="ndrc_identification"
                        value={content.formData.ndrc_identification}
                        onChange={handleInputChange}
                        options={content.lookupTypes?.ndrcIdentification || []}
                        disabled={content.inputDisable}
                        error={!!content?.errors?.ndrc_identification}
                      />
                    </Grid>
                  </Box>
                  {content.formData.ndrc_identification === 'Other' &&
                    <Box sx={{ mb: 2 }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2}>
                          <NCRFormLabel>NDRC Identification:</NCRFormLabel>
                        </Grid>
                        <NCRTextField
                          size='small'
                          sx={{ width: '340px' }}
                          multiline
                          name="ndrc_identification_other"
                          onChange={handleInputChange}
                          disabled={content.inputDisable}
                          value={content.formData.ndrc_identification_other || ''}
                          placeholder="Enter NDRC identification"
                          error={!!content?.errors?.ndrc_identification_other}
                          maxLength={250}
                        />
                      </Grid>
                    </Box>
                  }
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: '50%', mr: 4 }}>
                <Grid item xs={4}>
                  <NCRFormLabel sx={{ mb: 1 }}>
                    Corrective Actions for Non-Detected Root Cause (NDRC):
                  </NCRFormLabel>
                </Grid>
                <Grid item xs={8}>
                  <NCRMultilineTextfields
                    name="corrective_actions_ndrc"
                    value={content.formData.corrective_actions_ndrc || ""}
                    onChange={handleInputChange}
                    error={!!content?.errors?.corrective_actions_ndrc}
                    disabled={content.inputDisable}
                    placeholder={!content.inputDisable ? 'Enter corrective actions for process root cause' : "No data entered"}
                  />
                </Grid>
              </Box>
              {!content?.inputDisable && content?.label !== 'edit' &&
                <AILabelBox
                  label="corrective_actions_ndrc"
                  handleAIClick={(fieldName) => handleAIClick(fieldName, content, onAiResponseChange)}
                  aiResponse={content.aiResponse || {}}
                  onChange={onChange}
                />
              }
            </Box>
          </Box>
          <Divider sx={{ mt: 1 }} />
        </Box>
      </ThemeProvider >
    </>
  );
};
